import AlarmRaiseOption from "../enums/AlarmRaiseOptionTypes";

export default interface ServerTypeEvent {
	serverTypeID: number;
	eventNum: number;
	groupID?: number | null;
	title: string;
	description: string;
	matchGeofence: boolean;
	matchRadius?: number | null;
	defaultPriority?: number | null;
	defaultScript?: number | null;
	defaultTag?: number | null;
	isRaiseIndividual?: boolean | null;
	ignoreDefaultAlarm?: boolean | null;
	eventCode: string;
	restoreCode: string;
	restored: boolean;
	restorable: boolean;
	allowExtraText?: boolean | null;
	defaultExpectedFrequencyInSeconds?: number | null;
	showInSituationAwareness?: boolean | null;
	slaBreachSeconds?: number | null;
}

export interface ServerTypeEventExtendedDto extends ServerTypeEvent {
	canEdit: boolean;
	groupTitle: string;
	defaultScriptTitle? : string | null;
	defaultTagTitle?: string | null;
	alarmBehavior?: AlarmRaiseOption | null;
}

export interface ServerTypeEventSelectionOption {
    eventNum: number;
    title: string;
}

export const DefaultServerTypeEvent: ServerTypeEventSelectionOption = {
    eventNum: -1,
    title: "Default",
}